
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'message-video',

	props: {
		src: String,
		hosting: {
			type: String,
			default: 'youtube'
		},

		autoplay: {
			type: Boolean,
			default: false
		},

		isWidget: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		getYoutubeLink(link: string) {
			const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
			const match = link.match(regExp);
			if (match && match[2].length === 11) {
				const url = new URL(`https://www.youtube.com/embed/${match[2]}`);
				if (this.autoplay) {
					url.searchParams.set('autoplay', '1');
					url.searchParams.set('mute', '1');
				}
				return url.toString();
			}
			return '';
		},
		getVimeoLink(link: string) {
			const regExp =
				/https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
			const match = link.match(regExp);
			if (match && match[3]) {
				const url = new URL(`https://player.vimeo.com/video/${match[3]}`);
				if (this.autoplay) {
					url.searchParams.set('autoplay', '1');
				}
				return url.toString();
			}
			return '';
		},
		getVKLink(link: string) {
			const regExp = /video(-?\d+)_(\d+)/;
			const match = link.match(regExp);
			if (match && match[1] && match[2]) {
				const url = new URL(
					`https://vk.com/video_ext.php?oid=${match[1]}&id=${match[2]}`
				);
				if (this.autoplay) {
					url.searchParams.set('autoplay', '1');
				}
				return url.toString();
			}
			return '';
		},
		getRutubeLink(link: string) {
			const regExp = /rutube\.ru\/video\/(?:private\/)?([a-f0-9]+)(?:\/?\?p=([^&]+))?/;
			const match = link.match(regExp);

			if (match && match[1]) {
				const videoId = match[1];
				const pParam = match[2] ? `?p=${match[2]}` : '';
				const baseUrl = `https://rutube.ru/play/embed/${videoId}/${pParam}`;
				const url = new URL(baseUrl);
				if (this.autoplay) {
					url.searchParams.set('autoplay', 'true');
				}
				return url.toString();
			}
			return '';
		},
		getIframeLink(link: string, hosting: string | null) {
			if (link && link !== '') {
				if (hosting === 'youtube') {
					return this.getYoutubeLink(link);
				} else if (hosting === 'vimeo') {
					return this.getVimeoLink(link);
				} else if (hosting === 'vk') {
					return this.getVKLink(link);
				} else if (hosting === 'rutube') {
					return this.getRutubeLink(link);
				} else {
					return this.getYoutubeLink(link);
				}
			}
			return '';
		}
	},

	computed: {
		videoLink(): string {
			if (this.isLoadedVideo) {
				return this.src || '';
			}
			return this.src ? this.getIframeLink(this.src, this.hosting) : '';
		},
		// Проверяем является ли видео загруженным на платформу
		isLoadedVideo(): boolean {
			return (
				!!this.src?.includes('dev.buddybot.tools') || !!this.src?.includes('borisbot.com')
			);
		}
	}
});
